import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const KbPostCategoryService = new ModelService(apiRoutes.kbPostCategory, '/kb-post');

KbPostCategoryService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.kbPostCategory}`, params);
  return { data, count: parseInt(count, 10) };
});

KbPostCategoryService.modelName = 'KbPostCategory';

export default KbPostCategoryService;



// WEBPACK FOOTER //
// ./src/services/kbPostCategory.service.js